
import CartCheckout from '../components/CartCheckout'

export default {
  components: {
    CartCheckout
  }
}
